import { createInstanceWithChildren } from '../../../utils/dynamic-items-utils';
import { productTitle } from '../product-item-elements/product-title';
import { itemMediaPreview } from '../product-item-elements/item-media-preview';
import { deliveryDateContainer } from '../product-item-elements/delivery-date';
import { quantityText } from '../product-item-elements/quantity-text';

const itemContentType = createInstanceWithChildren({
  contentTypeId: 'dynamic-collections-renderer',
  styles: {
    classes: ['d-block', 'position-relative'],
    style: {
      __multiple__: {
        provider: 'id:root',
        property: 'singleItemStyle',
      },
    },
  },
  data: {
    itemData: {
      provider: 'parent',
      property: 'itemData',
    },
  },
  children: [
    productTitle,
    {
      contentTypeId: 'dynamic-collections-renderer',
      styles: {
        classes: ['position-relative'],
      },
      children: [itemMediaPreview, deliveryDateContainer, quantityText],
    },
  ],
});

export const ProductThumbnailWithQuantities = createInstanceWithChildren({
  contentTypeId: 'dynamic-collections-renderer',
  styles: {
    dynamicClasses: { provider: 'id:root', property: 'singleItemClass' },
  },
  data: {
    itemData: {},
  },
  children: [itemContentType],
});
